import React from 'react';
import { ArrowRight, BookOpen } from 'lucide-react';
import { guides } from '../mock';
import { useApp } from '../context/AppContext';
import { SectionHeading } from './LatestProjects';
import { openEnquiry } from './EnquiryModal';

export const GuidesSection = () => {
  const { t } = useApp();
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
      <SectionHeading title={t('guides')} linkLabel={t('view_all_guides')} to="/contact" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {guides.map((g) => (
          <div key={g.id} className="group relative rounded-xl overflow-hidden aspect-[3/4] card-lift cursor-pointer" onClick={() => openEnquiry(g.title)}>
            <img src={g.image} alt={g.title} loading="lazy" className="h-full w-full object-cover img-zoom" />
            <div className="absolute inset-0 bg-gradient-to-t from-gobra-slate/90 via-gobra-slate/20 to-transparent" />
            <div className="absolute bottom-0 p-5 text-white">
              <div className="inline-flex items-center gap-1.5 text-gobra-orange text-xs font-semibold mb-2">
                <BookOpen className="h-3.5 w-3.5" /> {g.tag}
              </div>
              <h3 className="font-title text-lg font-semibold leading-snug">{g.title}</h3>
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-white/80 group-hover:text-gobra-orange transition-colors">
                {t('read_more')} <ArrowRight className="h-3.5 w-3.5" />
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export const AgentsSection = () => {
  const { t, agents } = useApp();
  return (
    <section className="bg-gobra-slate py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <div className="h-1 w-12 bg-gobra-orange rounded-full mb-3" />
            <h2 className="font-title text-2xl md:text-4xl font-bold text-white">{t('our_teams')}</h2>
            <p className="text-white/60 mt-2 max-w-lg">{t('agents_desc')}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {agents.map((a) => (
            <div key={a.id} className="group bg-white/5 border border-white/10 rounded-xl overflow-hidden hover:bg-white/10 transition-colors">
              <div className="aspect-square overflow-hidden">
                <img src={a.photo} alt={a.name} loading="lazy" className="h-full w-full object-cover img-zoom" />
              </div>
              <div className="p-4">
                <h3 className="font-title text-base font-semibold text-white leading-tight">{a.name}</h3>
                <p className="text-white/60 text-xs mt-1">{t(a.role)}</p>
                <p className="text-gobra-orange text-[11px] mt-2 tracking-wide">{a.langs}</p>
                <button onClick={() => openEnquiry(`Consultation with ${a.name}`)}
                  className="mt-3 w-full text-xs font-medium bg-gobra-green hover:bg-gobra-terracotta text-white rounded-full py-2 transition-colors">
                  {t('contact_agent')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
